module.exports = __webpack_public_path__ + "img/20191019154355547.43f8295a.jpg";